import React from "react";


import reactAnimation from "../../assets/img/blogs/react_animation.png";
import javaScriptPost from "../../assets/img/blogs/javascript.png";
import reactPost from "../../assets/img/blogs/react.jpeg";

import BlogPost from "../BlogPost/BlogPost";

const Blogs = () => {

  const blogs = [
    {
      image: reactAnimation,
      title: "Everything you need to know about React Animation",
      live: "https://abid22.medium.com/everything-you-need-to-know-about-react-animation-bb2ad83ef9b8"
    },
    {
      image: javaScriptPost,
      title: "Javascript Interview Questions You Should Know",
      live: "https://abid22.medium.com/javascript-interview-questions-you-should-know-e49d53eded4f"
    },
    {
      image: reactPost,
      title: "Core Concepts of React: Why you should learn it?",
      live: "https://abid22.medium.com/core-concepts-of-react-why-you-should-learn-it-e7498fd87ddc"
    },
  ]

  return (
    <div className="container mt-5">
      <h1 className="text-center text-white mb-5 mt-5">Some of my Articles</h1>
      <div className="row">
        
        {
          blogs.map(blog => <BlogPost blog={blog}/>)
        }
      </div>
    </div>
  );
};

export default Blogs;
